import _ from 'lodash';
(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("learningPlanService", ["learningPlanResource", learningPlanService]);
    function learningPlanService(learningPlanResource) {
        var learningPlanServiceFactory = {
            data: {},
            lastUpdated: null
        };
        var addToPlan = function (number, version, callback) {
            learningPlanResource.addToPlan({ number: number, version: version }, function () {
                learningPlanServiceFactory.data = {};
                if (callback)
                    callback();
            });
        };
        var getData = function () {
            //Clear data if older than 1 minute.
            if (learningPlanServiceFactory.lastUpdated && moment().valueOf() - learningPlanServiceFactory.lastUpdated > 60000)
                learningPlanServiceFactory.data = {};
            if (learningPlanServiceFactory.data.$resolved) {
                console.log("LearningPlanService getData from cache");
                return learningPlanServiceFactory.data.$promise;
            }
            else {
                var promise = learningPlanResource.get().$promise.then(function (result) {
                    learningPlanServiceFactory.data = result;
                    learningPlanServiceFactory.lastUpdated = moment().valueOf();
                    console.log("LearningPlanService data fetched");
                    return result;
                }).catch(angular.noop);
                return promise;
            }
        };
        var refresh = function (callback) {
            learningPlanResource.get(function (result) {
                learningPlanServiceFactory.data = result;
                learningPlanServiceFactory.lastUpdated = moment().valueOf();
                console.log("LearningPlanService data refreshed");
                if (callback)
                    callback();
            });
        };
        var isPathOnPlan = function (number, version) {
            return _.some(learningPlanServiceFactory.data.learningPaths, function (path) {
                return path.number === number && path.version === version;
            });
        };
        //function updatePaths(data) {
        //	learningPlanServiceFactory.paths = data.learningPaths;
        //}
        learningPlanServiceFactory.addToPlan = addToPlan;
        learningPlanServiceFactory.isPathOnPlan = isPathOnPlan;
        learningPlanServiceFactory.getData = getData;
        learningPlanServiceFactory.refresh = refresh;
        return learningPlanServiceFactory;
    }
}());
